import React from 'react';
import { Box } from '@mui/material';
import { BrowserRouter as Router, Navigate, Route, Routes, useLocation } from 'react-router-dom'
import Footer from './components/Footer';
import Header from './components/Header';
import Home from './components/mainContent/Home'
import Services from './components/mainContent/Services';
import Work from './components/mainContent/Work';
import Mentorship from './components/mainContent/Mentorship';
import Resume from './components/mainContent/Resume';
import Contact from './components/mainContent/Contact';
import NotFound from './components/mainContent/NotFound';

/** Scrolls to the top on page change, or to the #anchor when one is present. */
function ScrollManager() {
  const { pathname, hash } = useLocation()

  React.useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1))
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' })
        return
      }
    }
    window.scrollTo(0, 0)
  }, [pathname, hash])

  return null
}

export function AppRoutes() {
  return (
    <>
      <ScrollManager />
      <Box component="a" href="#main" sx={{ position: 'absolute', left: -9999, '&:focus': { left: 16, top: 16, zIndex: 2000, p: 1, backgroundColor: 'white' } }}>
        Skip to content
      </Box>
      <Header />
      <Box component="main" id="main">
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/services' element={<Services />} />
          <Route path='/work' element={<Work />} />
          <Route path='/portfolio' element={<Navigate to='/work' replace />} />
          <Route path='/mentorship' element={<Mentorship />} />
          <Route path='/resume' element={<Resume />} />
          <Route path='/contact' element={<Contact />} />
          <Route path='*' element={<NotFound />} />
        </Routes>
      </Box>
      <Footer />
    </>
  )
}

function App() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  )
}

export default App;
